export default "__VITE_ASSET__4e78137c__"